
/* injects from baggage-loader */

'use strict';

export default class MainController {
    constructor($log, $state, $rootScope, Session, $Forms, Trophies, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.Session = Session;
        this.$Forms = $Forms;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.textHelp = 'ESCOLHA UMA CATEGORIA E DEPOIS ARRASTE AS FIGURAS PARA COLAR NO ÁLBUM. POR EXEMPLO, SE VOCÊ ESCOLHEU <b>COR</b>, DEVE COLAR NA FOLHA DO ÁLBUM APENAS FIGURAS DA <b>COR</b> QUE AS PÁGINAS PEDEM.';
        
        this.stageContainer = document.querySelector('body .stage-container');
    }

    $onInit(){
        
        this.stages = this.Session.get().stages;            
        angular.element(this.stageContainer).addClass('stage-bg-2');
        
    }
    
    $onDestroy(){
        angular.element(this.stageContainer).removeClass('stage-bg-2');
        return false;
    }

    goTo(route, disabled){
        if(!disabled) this.$state.go(route);
    }

    toStagesMenu(){
        this.Dialog.showStagesModal( () => {
            this.$log.log('Close Menu');
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.controller.js